import { HttpErrorResponse } from '@angular/common/http';
import {
  AfterViewInit,
  Component,
  Inject,
  OnInit,
  ViewChild
} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogConfig,
  MatDialogRef
} from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { IServicos } from '@app/modules/servicos/models/servicos.model';
import { ServicoService } from '@app/modules/servicos/services/servico.service';
import {
  ConfirmDialogComponent,
  ConfirmDialogData
} from '@app/shared/components';
import { Utils } from '@app/shared/helpers/utils';
import { ScreenService } from '@app/shared/services';
import { Dialog } from 'primeng/dialog';
import {
  CustomValidators,
  ErroMessages,
  IErroMessages,
  IRoute,
  TokenService
} from 'viggo-sistemas-core-web';
import { CategoriaServicoService } from '../../../categoria-servicos/services/categoria_servico.service';

@Component({
  templateUrl: './fast-servico.component.html',
  styleUrls: ['./fast-servico.component.scss'],
  providers: [ServicoService, CategoriaServicoService]
})
export class FastServicosComponent implements OnInit, AfterViewInit {
  @ViewChild('fastServico') fastServico: Dialog;
  public form: UntypedFormGroup;

  loading = false;

  displayMessage = {
    descricao: {
      duplicate:
        'Já existe um serviço criado com o mesmo nome para a mesma categoria!',
      required: 'Descrição é obrigatória',
      maxlength: 'Não pode ter mais de 500 caracteres',
      isEmptyValue: 'Valor inválido: remova os campos em branco!'
    },
    valor: {
      required: 'Valor é obrigatório',
      min: 'Valor deve ser maior que 0',
      max_value: 'Inválido: passou dos limite',
      before_split: 'Inválido: erro na parte inteira',
      after_split: 'Inválido: erro na parte decimal',
      errorComma: 'Inválido: excesso de virgulas',
      errorDots: 'Inválido: excesso de pontos',
      notNumbers: 'Inválido: insira um número',
      invalidNumber: 'Valor inválido'
    }
  };

  constructor(
    public screenService: ScreenService,
    public dialogRef: MatDialogRef<FastServicosComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IServicos,
    protected fb: UntypedFormBuilder,
    public entityService: ServicoService,
    public categoriaServicoService: CategoriaServicoService,
    public tokenService: TokenService,
    protected matSnackBar: MatSnackBar,
    public matDialog: MatDialog,
    public router: Router
  ) {}

  ngAfterViewInit(): void {
    if (this.screenService.detectDeviceInfo().isMobile)
      this.fastServico.maximize();
  }

  ngOnInit() {
    this.form = this.fb.group({
      valor: [
        0,
        [Validators.required, CustomValidators.validateCurrencyValues(17, 4)]
      ],
      descricao: [
        '',
        [
          Validators.required,
          Validators.maxLength(500),
          CustomValidators.isEmptyValue()
        ]
      ],
      categoria_servico: [
        null,
        [
          Validators.required,
          CustomValidators.typeIs('object'),
          CustomValidators.isEmptyValue()
        ]
      ]
    });
    this.validateForm();
  }

  onSubmit() {
    if (this.form.valid) {
      this.loading = true;
      const { ...rest } = this.form.value;
      var entity = { domain_id: this.tokenService.getDomain().id, ...rest };
      entity.valor = Utils.replaceCommaToDot(entity.valor);
      entity = Utils.trimAttributes(entity);
      entity.categoria_servico_id = entity.categoria_servico.id;
      delete entity.categoria_servico;
      this.checarServico(entity);
    }
  }

  validateOnlyNumbers(event) {
    if (
      !/^\d+$/.test(event.key) &&
      !/[`,.]/.test(event.key) &&
      !event.ctrlKey &&
      event.key !== 'Backspace' &&
      event.key !== 'Delete' &&
      event.key !== 'Tab' &&
      event.key !== 'ArrowLeft' &&
      event.key !== 'ArrowRight'
    )
      return false;
  }

  markAllControlsAsDirty() {
    Object.keys(this.form.controls).forEach(controlKey => {
      controlKey = String(controlKey);
      const control = this.form.get(controlKey);
      if (!control || control.valid) return;
      control.markAsDirty();
    });
  }

  validateForm() {
    this.form.markAllAsTouched();
    this.markAllControlsAsDirty();
  }

  checkDisponibilidade(action: string, params = '', url_name: string) {
    var routesAuthorization = this.verificarRotasDeAcesso(
      this.tokenService.getRoutes(),
      url_name
    ) as IRoute[];

    return this.validarAdicao(routesAuthorization, action, params, url_name);
  }

  /**
   * Valida as rotas do usuário
   * @param routes
   * @param url_name
   * @returns
   */
  verificarRotasDeAcesso(routes: IRoute[], url_name: string): IRoute[] {
    if (routes && routes.length > 0 && url_name) {
      return routes.filter(r => new RegExp(`^${url_name}`).test(r.url));
    }
  }

  /**
   * Valida se as rotas do usuário são equivalentes ao pacote de rotas do fiscal
   * @param routesAuthorization
   * @param action
   * @param params
   * @param url_name
   * @returns
   */
  validarAdicao(
    routesAuthorization: IRoute[],
    action: string,
    params = '',
    url_name: string
  ): boolean {
    if (routesAuthorization && routesAuthorization.length > 0) {
      const url_return = routesAuthorization.find(
        route => route.url === url_name && route.method === action
      );
      return !!url_return;
    }
  }

  checarServico(entity) {
    const { descricao, categoria_servico } = this.form.controls;

    if (
      descricao.invalid ||
      descricao.value === '' ||
      categoria_servico.invalid ||
      categoria_servico.value === ''
    )
      return;

    this.entityService
      .getEntitiesByParams(
        {
          where: {
            descricao: `${(descricao.value as string).trim()}%`,
            categoria_servico_id: categoria_servico.value.id,
            domain_id: this.tokenService.getDomain().id
          },
          pagination: {
            page: 0,
            page_size: 1
          }
        },
        undefined,
        true
      )
      .subscribe(
        res => {
          this.loading = false;
          if (res.data.length > 0) {
            descricao.setErrors({ duplicate: true });
            categoria_servico.setErrors({ duplicate: true });
          } else {
            this.entityService.insert(entity).subscribe(
              servico => {
                if (servico) {
                  this.entityService
                    .getEntity(servico.id, ['categoria_servico'])
                    .subscribe(
                      res => {
                        this.matSnackBar.open(
                          `Novo serviço cadastrado com sucesso.`,
                          'X',
                          {
                            duration: 2000,
                            horizontalPosition: 'right',
                            verticalPosition: 'top',
                            panelClass: ['msg-success']
                          }
                        );
                        this.dialogRef.close(res);
                      },
                      (err: HttpErrorResponse) => {
                        this.displayError(err);
                        this.loading = false;
                      },
                      () => {
                        this.loading = false;
                      }
                    );
                }
              },
              (err: HttpErrorResponse) => {
                this.displayError(err);
                this.loading = false;
              }
            );
          }
        },
        (err: HttpErrorResponse) => this.displayError(err)
      );
  }

  displayError(err: HttpErrorResponse, showDefaultMsg = false) {
    const errorMsg = new ErroMessages({
      route: this.router.url,
      router: this.router,
      matSnackBar: this.matSnackBar,
      httpError: err,
      showDefaultMsg: showDefaultMsg,
      loginService: null,
      tokenService: this.tokenService,
      dialogComponent: ConfirmDialogComponent,
      matDialog: this.matDialog,
      dialogData: {
        config: {
          data: {
            title: 'Aviso - Erro ao realizar operação',
            bodyMessage: err.error,
            icon: 'warning',
            icon_color: 'accent',
            singleBtn: true
          } as ConfirmDialogData,
          disableClose: true,
          width: '500px'
        } as MatDialogConfig<any>
      }
    } as IErroMessages);
    errorMsg.showMessageObject(err.error);
    // errorMsg.checkError();
  }
}
